import BaseService from "./BaseService";

const BASE = "/users/uploads";

export const uploadUsers = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return BaseService.callAPI(
    BASE,
    "POST",
    formData,
    {},
    { contentType: "multipart/form-data" }
  );
};

export const getUserUploads = (query = {}) => {
  const params = new URLSearchParams(
    BaseService.cleanQueryParams(query)
  ).toString();
  return BaseService.callAPI(`${BASE}?${params}`);
};

// The upload dialog polls without the rows (includeRows: false) and asks for
// them once, when the status is final.
export const getUserUpload = (id, { includeRows = true } = {}) =>
  BaseService.callAPI(
    includeRows ? `${BASE}/${id}` : `${BASE}/${id}?includeRows=false`
  );

export const downloadUploadOriginal = (id) =>
  BaseService.callAPI(`${BASE}/${id}/original`, "GET", null, {
    responseType: "blob",
  });

export const downloadUploadResults = (id) =>
  BaseService.callAPI(`${BASE}/${id}/results`, "GET", null, {
    responseType: "blob",
  });
